<template>
  <div style="min-width: 1300px;">
  	
  <layout :hideSplit="true">
  	 <div slot="body" scope="props" >
  	 	<banner></banner>
  	 	<service></service>
  	 	<dataCenter></dataCenter>
  	 	<agencylist></agencylist>
  	 </div>
  </layout>
  	
  	
   
  </div>
</template>

<script>
import layout from '../layout/index.vue'
import banner from './banner/index.vue'
import service from './service/index.vue'
import dataCenter from './dataCenter/index.vue'
import agencylist from './agencylist/index.vue'

export default {
  name: 'index',
	components: {
		layout:layout,
		banner:banner,
		service:service,
		dataCenter:dataCenter,
		agencylist:agencylist
	}
}
</script>

<style scoped>
	
	
</style>



// WEBPACK FOOTER //
// src/view/v2/index/index.vue